export function isImageSquare(width, height) {
    if(!height || !width) return true;
    return height === width ? true : false
}